// extracted by mini-css-extract-plugin
export default {"popover":"ColumnHeaderLabelWithFilter_popover__GCR2A","sort-label":"ColumnHeaderLabelWithFilter_sort-label__tgY1P"};